import { evaluateScreenLoad, setScreenLoadTimingGate } from '@/utils/screen-load-timing/screenLoadTiming'

const buildSnapshot = (state, getters) => ({
  routeName: state.route?.name ?? null,
  routePresentationId: state.route?.params?.id ?? null,
  isPresenting: Boolean(getters.isPresenting),
  presentationId: state.presentation?.id ?? null,
  slideCount: state.presentation?.slides?.length ?? 0,
  activeSlideId: state.slideActive?.id ?? null,
})

const screenLoadTimingPlugin = (store) => {
  setScreenLoadTimingGate(() => Boolean(store.getters['featureToggles/canUsePresenterPerformanceTelemetry']))

  store.watch(
    (state, getters) => {
      const snapshot = buildSnapshot(state, getters)
      return getters['featureToggles/canUsePresenterPerformanceTelemetry'] ? JSON.stringify(snapshot) : null
    },
    (serialisedSnapshot) => {
      if (serialisedSnapshot) evaluateScreenLoad(JSON.parse(serialisedSnapshot))
    },
    { immediate: true },
  )
}

export default screenLoadTimingPlugin
